import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {Product} from '../../../../../models/product';
import {Paginator} from '../../../../../tools/pagination/paginator';
import {TableSorter} from '../../../../../tools/table-sorter/table-sorter';
import {LoaderService} from '../../../../../services/loader/loader.service';
import {SnackbarService} from '../../../../../services/snackbar/snackbar.service';
import {ProductService} from '../../../../../services/product/product.service';
import {ConfirmDirective} from '../../../../../directives/confirm/confirm.directive';
import { NgOptimizedImage } from '@angular/common';
import {PaginatorComponent} from '../../../../layout/paginator/paginator.component';
import {TableSorterHeaderDirective} from '../../../../../directives/table-sorter/table-sorter-header.directive';
import {TableSorterDirective} from '../../../../../directives/table-sorter/table-sorter.directive';
import {RouterLink} from '@angular/router';
import {IsGranted} from '../../../../../decorator/is-granted';
import {IsGrantedDirective} from '../../../../../directives/is-granted/is-granted.directive';
import {ImageService} from '../../../../../services/image/image.service';
import {MetaTitle} from '../../../../../decorator/meta-title';
import {LangService} from '../../../../../services/language/lang.service';

@Component({
  selector: 'app-product-list',
    imports: [
    ConfirmDirective,
    PaginatorComponent,
    TableSorterHeaderDirective,
    TableSorterDirective,
    RouterLink,
    IsGrantedDirective,
    NgOptimizedImage
],
  templateUrl: './product-list.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './product-list.component.scss'
})
@IsGranted(['PRODUCT_VIEW'])
@MetaTitle('Products')
export class ProductListComponent implements OnInit {
  products: Product[] = [];
  paginator: Paginator = new Paginator();
  tableSorter: TableSorter = new TableSorter('id', 'asc');

  constructor(
    protected imageService: ImageService,
    private loader: LoaderService,
    private snackbar: SnackbarService,
    private productService: ProductService,
    protected langService: LangService
  ) {
  }

  ngOnInit(): void {
    this.refresh();
  }

  refresh(): void {
    this.fetchAll();
  }

  fetchAll(): void {
    this.loader.startLoading();

    this.productService.findAll({groups: 'advertiser'}, this.paginator, this.tableSorter).subscribe((products) => {
      this.products = products;

      this.loader.stopLoading();
    })
  }

  delete(product: Product): void {
    if (product.id) {
      this.loader.startLoading();
      this.productService.delete(product.id).subscribe(() => {
        this.loader.stopLoading();
        this.snackbar.success('Product has been deleted');
        this.refresh();
      });
    }
  }
}
